import React from "react";
import {
  Button,
  ButtonText,
  Container,
  IconContainer,
  TextContainer,
  ButtonContainer,
} from "./styled-components";
import Text from "../text";
import { ReactComponent as ArrowIcon } from "../../assets/icons/arrow.svg";

const ConfirmationBloc = ({ onClick }: { onClick: () => void }) => {
  return (
    <Container>
      <TextContainer>
        <Text size="24px" lineHeight="32px" align="left">
          Êtes-vous bien sûr d’avoir fait toutes les démarches ?
        </Text>
        <Text>
          Si toutes les étapes inscrites ci-dessus ont été effectuées, vous
          pouvez alors démarrer la constitution de votre dossier. Dans le cas
          contraire, vous pouvez vous rendre dans un point de justice afin
          d'être aidé dans la réalisation des démarches.{" "}
          <a
            href="http://www.annuaires.justice.gouv.fr/annuaires-12162/les-point-justice-34055.html"
            target="_blank"
            rel="noreferrer"
          >
            Trouver votre point-justice
          </a>
        </Text>
      </TextContainer>
      <ButtonContainer>
        <Button onClick={onClick}>
          <ButtonText>Oui, j'ai bien fait toutes les démarches</ButtonText>
          <IconContainer>
            <ArrowIcon />
          </IconContainer>
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default ConfirmationBloc;
